import { apiGetSchoolData } from '../../common/api/school'
import {
  apiUpdateStudent,
  apiRetireStudent,
  apiCreateStudent,
  apiAddStudentToAGroup,
  apiRemoveStudentFromGroup,
  apiIncrementAgeGroup,
  apiAddPermissionToStudent,
  apiRemovePermissionFromStudent,
  apiExportStudentsToCSV
} from '../../common/api/student-management'
import { getGroups } from '../groups/groups.selectors'

const setPupils = pupils => ({ type: 'PUPILS_STORE:SET_PUPILS', pupils })

const createPupilBatch = request => ({
  requestPrefix: 'PUPILS_STORE:CREATE_PUPIL_BATCH',
  request: request
})

const createPupil = (id, schoolId, data) => ({
  requestPrefix: 'PUPILS_STORE:CREATE_PUPIL',
  params: { id },
  request: () => apiCreateStudent(schoolId, data)
})

const updatePupil = (id, data) => ({
  requestPrefix: 'PUPILS_STORE:UPDATE_PUPIL',
  params: { id },
  request: () =>
    apiUpdateStudent(id, data, {
      include:
        'account.student_type.year_group,account.student_type.year_group.names,account.student_type.year_group.order'
    })
})

const retirePupil = id => ({
  requestPrefix: 'PUPILS_STORE:RETIRE_PUPIL',
  params: { id },
  request: () => apiRetireStudent(id)
})

const fetchPupils = schoolId => ({
  requestPrefix: 'PUPILS_STORE:FETCHING',
  request: () =>
    apiGetSchoolData(schoolId, {
      include:
        'school.student_types,school.student_type.dob,school.student_type.passcode,school.student_type.account.names,school.student_type.year_group,school.student_type.year_group.names,school.student_type.year_group.order,school.student_type.policy,school.student_type.groups,school.student_type.group.names,school.student_type.works_count'
    })
})

const addPupilToGroup = (id, data) => (dispatch, getState) =>
  dispatch({
    requestPrefix: 'PUPILS_STORE:ADD_PUPIL_TO_GROUP',
    params: { id, groups: getGroups(getState()) },
    request: () => apiAddStudentToAGroup(data)
  })

const removePupilFromGroup = data => ({
  requestPrefix: 'PUPILS_STORE:REMOVE_PUPIL_FROM_GROUP',
  params: { id: data.student_account_id, groupId: data.group_id },
  request: () => apiRemoveStudentFromGroup(data)
})

const incrementAgeGroup = id => ({
  requestPrefix: 'PUPILS_STORE:INCREMENT_AGE_GROUP',
  params: { id: id },
  request: () =>
    apiIncrementAgeGroup(id, {
      include:
        'account.student_type.year_group,account.student_type.year_group.names,account.student_type.year_group.order'
    })
})

const addPermission = id => ({
  requestPrefix: 'PUPILS_STORE:ADD_PERMISSION',
  params: { id },
  request: () => apiAddPermissionToStudent(id)
})

const removePermission = id => ({
  requestPrefix: 'PUPILS_STORE:REMOVE_PERMISSION',
  params: { id },
  request: () => apiRemovePermissionFromStudent(id)
})

const exportCSV = ids => ({
  requestPrefix: 'PUPILS_STORE:EXPORT_CSV',
  request: () => apiExportStudentsToCSV(ids)
})

export {
  addPermission,
  removePermission,
  setPupils,
  fetchPupils,
  updatePupil,
  retirePupil,
  createPupil,
  addPupilToGroup,
  removePupilFromGroup,
  incrementAgeGroup,
  createPupilBatch,
  exportCSV
}
